import React from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import { RootState, useSelector } from "src/store";

import { RemoveUniversalStatusDialog } from "@dashboard/licenses/components/RemoveUniversalStatusDialog";
import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { License } from "@devices/types";
import { selectGroupById } from "@groups/store/selectors";
import { PermissionService } from "@services/permissionService/permissionService";
import { DangerOutlinedButton } from "@shared/CustomButton";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

export const ActionCell = (props: License) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const { t } = useTranslation(["sidepanels"]);
    const { data: workspace } = useCurrentWorkspace();
    const location = useSelector((state: RootState) => selectGroupById(state, props.groupId), shallowEqual);

    const permission = PermissionService();
    const cannotRemove = permission.groupAbility(location || null, workspace).cannot("manage", "UniversalLicense");

    return (
        <MinimalTableCell align="right" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            <DangerOutlinedButton
                onClick={() => setIsDialogOpen(true)}
                disabled={cannotRemove}
                tooltipProps={{
                    title: cannotRemove
                        ? t("sidepanels:groupPanel.tooltip.cannotRemoveUniversalLicense")
                        : t("sidepanels:groupPanel.tooltip.deleteUniversalLicense"),
                }}
            >
                <i className="fa-solid fa-trash" />
            </DangerOutlinedButton>
            <RemoveUniversalStatusDialog license={isDialogOpen ? props : null} onClose={() => setIsDialogOpen(false)} />
        </MinimalTableCell>
    );
};
